import BatteryGradeSlideout from "./BatteryGradeSlideout";

export default BatteryGradeSlideout;
